import { Context } from "csi/def/Context";
import { CSS_TABLE_COLUMNS } from "csi/constants";
import { C8Node } from "src/c8-platform/type/node";
import ColumnEnumMap from "csi/table/matrix/ColumnEnumMap";
import declare from "dojo/_base/declare";
import Heading from "csi/def/Heading";
import Spec from "csi/heading/Spec";

const FoodBOMSubtypeActualItemsSelectionPreferenceMatrix = declare(ColumnEnumMap, {
	/**
	 * @override
	 * Return ActualItemsSelectionPreference spec with ProductType subspecs
	 */
	getColumnSpecs(ctx: Context, h: Heading): Spec[] {
		const specs = this.inherited<Spec[]>(arguments);
		const subs = [];

		// Add subspecs to new array
		specs.forEach((spec) => {
			const sub = spec.subs[0];
			sub.headerParams = spec.headerParams;
			subs.push(sub);
		});

		// Replace array of specs with single spec
		const newSpec = new Spec({
			css: CSS_TABLE_COLUMNS,
			heading: h,
			headerParams: {
				colSpan: subs.length,
				innerText: h.m_name,
			},
			subs,
		});

		return [newSpec];
	},

	/**
	 * @override
	 * C8FB-2599 Use inclusive filtering, only Food and Material columns should show up in the matrix
	 * Don't support Style in FoodBOM
	 * FormulatedMaterial will always be Product Centric so don't show in matrix
	 */
	_getColumnNodes(ctx: Context, h: Heading): C8Node[] | undefined {
		const keys = this.inherited(arguments) as unknown as C8Node[];
		return keys?.filter((key) => key.Value === "ProductType:Food" || key.Value === "ProductType:Material");
	},

	/**
	 * @override
	 * Grey out cell if not in ItemsProductTypes
	 */
	_getSpecNodes(ctx: Context, spec: Spec, nodes: C8Node[]): C8Node[] {
		const cache = ctx.cache;
		const foodBOMSubtype = ctx.getNode();
		const foodBOMSubtypeSettings = cache.getNode(foodBOMSubtype.SetupSettings);
		if (!foodBOMSubtypeSettings.ItemsProductTypes.includes(spec.index)) {
			return [];
		}
		return this.inherited<C8Node[]>(arguments);
	},

	/**
	 * @override
	 * Set index for column to enum
	 */
	onPathSubSpecParams(ctx: Context, params: any, columnIndex: number): void {
		const enumObj = ctx.getNodeAttributeValue("Value", false);
		params.index = enumObj;
	},
});

export = FoodBOMSubtypeActualItemsSelectionPreferenceMatrix;
